
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.973 2.752h2.699c.303 0 .71.148.922.85.116.382.12.758.12.774a.51.51 0 001.02.003c-.017-.837-.181-1.314-.316-1.567a2.323 2.323 0 00-.41-.574c-.355-.366-.772-.56-1.24-.575l-.02-.002H2.074a.51.51 0 00-.263.945l.007.004 1.042.622c.044.026.074.07.083.12l.531 2.74v.003a.51.51 0 00.996-.215.176.176 0 010-.07L3.8 2.971a.178.178 0 01.173-.219z","fill":"#A8D393"}}),_c('path',{attrs:{"d":"M22.56 8.754a.872.872 0 00-1.138-.83l-.002.001a.859.859 0 00-.132.056l-4.469 1.875c-.98.418-1.268.23-1.268.23L5.064 7.539l-.051-.012h-.002a1.008 1.008 0 00-1.163 1.268l1.118 5.06.001.008.32 1.444c.024.136.052.259.082.372l.112.507.002.007c.02.07.05.136.085.198l.006.013h.001a.875.875 0 00.37.339c.113.081.192.087.192.087l9.14 2.7a1.743 1.743 0 001.398-.158l4.509-2.22c.457-.216.504-.894.504-.894l.342-3.26a.87.87 0 00-1.213-.995l-.015.007c-.012.006-.025.011-.037.018l-4.061 1.995c-.735.39-1.586.058-1.586.058L8.33 12.144a.872.872 0 10-.559 1.646l7.795 2.167c.721.146 1.038-.104 1.038-.104l3.532-1.643-.086 1.283c-.058.331-.39.463-.39.463l-2.695 1.41c-1.168.62-1.6.476-1.6.476L6.97 15.375 5.719 9.438l9.615 2.249c1.024.216 1.701-.145 1.701-.145l4.936-1.964a.81.81 0 00.078-.031l.006-.003a.87.87 0 00.505-.79z","fill":"#52A728"}}),_c('path',{attrs:{"d":"M6.335 20.074a1.186 1.186 0 100-2.373 1.186 1.186 0 000 2.373zM14.829 22.48a1.186 1.186 0 100-2.373 1.186 1.186 0 000 2.372zM20.505 20.541a1.186 1.186 0 100-2.372 1.186 1.186 0 000 2.372z","fill":"#A8D393"}})])
          )
        }
      }
    